import { createSelector } from "reselect";
import get from "src/lib/get";
import { getData } from ".";

export const getSuggestedNextBillingDate = createSelector(getData, (data) => {
  return get(data, "suggested_next_billing_date", null);
});
